export default __webpack_public_path__ + "static/media/Logo.a77a385a.svg";